var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    _vm._b(
      {
        staticClass: "u-inputNumber",
        class: { isView: _vm.mode !== "edit" },
        attrs: {
          value: _vm.inputVal,
          placeholder: _vm.isDisabled ? "" : _vm.$t("common.pleaseInput"),
          clearable: "",
          disabled: _vm.isDisabled,
        },
        on: {
          blur: _vm.handleNumBlur,
          input: _vm.handleNumInput,
          change: _vm.handleNumChange,
        },
      },
      "el-input",
      _vm.$attrs,
      false
    ),
    [_c("template", { slot: "append" }, [_vm._t("append")], 2)],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }